// extracted by mini-css-extract-plugin
export default {"appbar":"Navbar_appbar__I7OxJ","toolbar":"Navbar_toolbar__u1VJO","brand":"Navbar_brand__49SEL","brandTitle":"Navbar_brandTitle__DEBPQ","brandSub":"Navbar_brandSub__ANW8n"};